import {
    Component,
    Input,
    Output,
    OnInit,
    EventEmitter,
    OnChanges,
    SimpleChange } from '@angular/core';
@Component({
    selector: 'itpx-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: [ './pagination.component.css' ]
})
export class PaginationComponent implements OnInit {
    @Input() itemsCount: number;
    @Input() limit: number;
    @Input() startPage: number;
    @Output() pageChange = new EventEmitter();

    private pages: Array<number>;
    private currentPage: number = 1;
    private pageCount: number;
    private visiblePages: Array<number>;

    ngOnInit() {
        this.setPages();
    }
    ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
        this.setPages();
        if(changes['limit'] || changes['itemsCount']) {
            let startPage = 1;
            if(this.startPage && changes['itemsCount']) {
                if(this.startPage <= this.pageCount) {
                    startPage = this.startPage;
                }
            }
            this.onPageClickInternal(startPage);
        }
    }
    onPageClick(page: number) {
        if (page !== this.currentPage && page >= 1 && page <= this.pageCount) {
            this.currentPage = page;
            this.pageChange.emit({
                page: this.currentPage
            });
            this.setVisiblePages();
        }
    }
    onPageClickInternal(page: number) {
        if (page !== this.currentPage && page >= 1 && page <= this.pageCount) {
            this.currentPage = page;
            this.setVisiblePages();
        }
    }
    private setPages() {
        this.pageCount = Math.ceil(this.itemsCount / this.limit);
        this.setVisiblePages();
    }
    private setVisiblePages() {
        if(this.pageCount < 6) {
            this.visiblePages = Array.apply(null, {length: this.pageCount}).map((x: number, i: number) => i + 1);
        } else {
            if(this.currentPage >= this.pageCount - 3) {
                let diff = this.pageCount - this.currentPage;
                let startPage = this.pageCount - 4;
                this.visiblePages = Array.apply(null, {length: 5}).map((x: number, i: number) => startPage + i);
            } else {
                if(this.currentPage < 3) {
                    let startPage = 1;
                    this.visiblePages = Array.apply(null, {length: 5}).map((x: number, i: number) => startPage + i);
                } else {
                    let startPage = this.currentPage - 2;
                    this.visiblePages = Array.apply(null, {length: 5}).map((x: number, i: number) => startPage + i);
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pagination/pagination.component.ts